import React, { useState } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Cell, ReferenceLine
} from 'recharts';

const territoryData = [
  { territory: 'NCR', actual: 92, target: 100, attainment: 92, status: 'warning' },
  { territory: 'Luzon N', actual: 78, target: 100, attainment: 78, status: 'danger' },
  { territory: 'Luzon S', actual: 105, target: 100, attainment: 105, status: 'success' },
  { territory: 'Visayas', actual: 88, target: 100, attainment: 88, status: 'warning' },
  { territory: 'Mindanao', actual: 71, target: 100, attainment: 71, status: 'danger' },
  { territory: 'Cebu', actual: 112, target: 100, attainment: 112, status: 'success' },
  { territory: 'Davao', actual: 95, target: 100, attainment: 95, status: 'warning' },
];

const colorMap = { success: '#059669', warning: '#D97706', danger: '#DC2626' };

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
      <p className="font-caption text-sm font-semibold mb-1" style={{ color: '#0F172A' }}>{label}</p>
      <p className="font-caption text-xs" style={{ color: '#475569' }}>Attainment: <span className="font-data font-semibold" style={{ color: '#1E293B' }}>{payload?.[0]?.value}%</span></p>
    </div>
  );
};

export default function TerritoryPerformanceChart() {
  const [metric, setMetric] = useState('attainment');
  return (
    <div className="card p-4 lg:p-6 chart-panel-depth">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h3 className="font-heading font-semibold text-lg lg:text-xl" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Territory Target Attainment</h3>
          <p className="font-caption text-sm mt-0.5" style={{ color: '#475569' }}>% of target achieved per territory</p>
        </div>
        <div className="flex items-center gap-3 font-caption" style={{ fontSize: '13px', fontWeight: 600, color: '#1A1A2E' }}>
          <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-success inline-block" />≥100%</span>
          <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-warning inline-block" />80–99%</span>
          <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-destructive inline-block" />&lt;80%</span>
        </div>
      </div>
      <div className="w-full chart-height-small" aria-label="Territory target attainment bar chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={territoryData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" strokeOpacity={0.6} />
            <XAxis dataKey="territory" tick={{ fontSize: 11, fontFamily: 'var(--font-caption)', fill: '#374151', fontWeight: 600 }} axisLine={{ stroke: '#E5E7EB' }} tickLine={false} />
            <YAxis domain={[0, 130]} tick={{ fontSize: 11, fontFamily: 'var(--font-data)', fill: '#374151', fontWeight: 600 }} unit="%" axisLine={false} tickLine={false} width={36} />
            <Tooltip content={<CustomTooltip />} />
            <ReferenceLine y={100} stroke="#D4AF37" strokeDasharray="4 4" strokeWidth={2} label={{ value: 'Target', position: 'right', fontSize: 12, fill: '#D4AF37', fontWeight: 700 }} />
            <Bar dataKey="attainment" radius={[4, 4, 0, 0]} style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.15))' }}>
              {territoryData?.map((entry) => (
                <Cell key={entry?.territory} fill={colorMap?.[entry?.status]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}